import type { IntakeSpec, IntakeSubType } from '@shared/types';
import type { Part, Joint, Feature } from '@shared/spec';

import * as table from './table';
import * as chair from './chair';
import * as shelf from './shelf';
import * as bed from './bed';
import * as desk from './desk';
import * as cabinet from './cabinet';
import * as bracket from './bracket';
import * as housing from './housing';
import * as gear from './gear';
import * as shaft from './shaft';
import * as fastenerPart from './fastenerPart';
import * as fixture from './fixture';
import * as building from './building';
import * as interiorRoom from './interiorRoom';
import * as site from './site';
import * as facadeDetail from './facadeDetail';
import * as decorative from './decorative';
import * as functional from './functional';
import * as replacement from './replacement';
import * as miniature from './miniature';
import * as enclosure from './enclosure';

type DispatchModule = {
  parts: (intake: IntakeSpec) => Part[];
  joints: (intake: IntakeSpec) => Joint[];
  features: (intake: IntakeSpec) => Feature[];
};

const DISPATCH: Record<IntakeSubType, DispatchModule> = {
  table, chair, shelf, bed, desk, cabinet,
  bracket, housing, gear, shaft, fastener_part: fastenerPart, fixture,
  building, interior_room: interiorRoom, site, facade_detail: facadeDetail,
  decorative, functional, replacement, miniature, enclosure,
};

export function derivePartsForSubType(intake: IntakeSpec): Part[] {
  return DISPATCH[intake.subType].parts(intake);
}

export function deriveJointsForSubType(intake: IntakeSpec): Joint[] {
  return DISPATCH[intake.subType].joints(intake);
}

export function deriveFeaturesForSubType(intake: IntakeSpec): Feature[] {
  return DISPATCH[intake.subType].features(intake);
}
